export default "/images/6bbe994ebf487b5f63a50a5579d7ebec.avif";